/**
 * DateGroup
 *
 * 날짜별 거래 그룹 헤더
 * - 날짜 (MM/DD 형식)
 * - 요일
 * - 해당 날짜의 총 수입/지출
 */

interface DateGroupProps {
  date: string // YYYY-MM-DD 형식
  totalIncome: number
  totalExpense: number
  inModal?: boolean  // 모달 내부 여부 (sticky 위치 조정용)
}

export function DateGroup({ date, totalIncome, totalExpense, inModal = false }: DateGroupProps) {
  // 날짜 파싱
  const dateObj = new Date(date + 'T00:00:00') // 로컬 타임존으로 파싱
  const month = dateObj.getMonth() + 1
  const day = dateObj.getDate()

  // 요일 계산
  const weekdays = ['일', '월', '화', '수', '목', '금', '토']
  const weekday = weekdays[dateObj.getDay()]

  return (
    <div className={`sticky ${inModal ? 'top-0' : 'top-[var(--month-nav-height)]'} z-[9] bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 px-4 py-2 border-b border-gray-200 dark:border-gray-600 transition-colors`}>
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
          {month}/{String(day).padStart(2, '0')} ({weekday})
        </span>
        <span className="text-sm text-gray-600 dark:text-gray-400">
          {totalIncome > 0 && (
            <span className="text-income-fixed">+{totalIncome.toLocaleString()}</span>
          )}
          {totalIncome > 0 && totalExpense > 0 && ' / '}
          {totalExpense > 0 && (
            <span className="text-expense-fixed">-{totalExpense.toLocaleString()}</span>
          )}
        </span>
      </div>
    </div>
  )
}
